import React, {
  useState,
  useMemo,
  useRef,
  // useEffect,
  useCallback,
} from "react";

import {
  // HeartIcon,
  EmptyHeartIcon,
} from "components/icons";

import { PhotoProvider, PhotoView } from "react-photo-view";

import {useTextTruncation} from "hooks/useTextTruncation"

export type IShowcaseCard = {
  username: string;
  time: string;
  likes: number;
  image: string;
  prompt: string;
};

interface ShowcaseCardProps {
  cardItem: IShowcaseCard;
  maxLines?: number;
  onSelected: () => void;
}

// const mobileBreakpoint = 540;

const ShowcaseCard: React.FC<ShowcaseCardProps> = ({
  cardItem,
  maxLines = 2,
  onSelected,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  // const [maxChars, setMaxChars] = useState<number>(cardItem.prompt.length); // 动态计算的最大字符数
  const containerRef = useRef<HTMLDivElement>(null);
  const textRef = useRef<HTMLSpanElement>(null);


    const { maxChars, isTruncated } = useTextTruncation({
    text: cardItem.prompt,
    maxLines,
    containerRef,
    textRef,
  });


  const firstChar = useMemo(
    () => cardItem.username?.charAt(0)?.toUpperCase() || "",
    [cardItem.username]
  );

  // // 计算最大字符数的函数
  // const calculateMaxChars = useCallback(() => {
  //   if (!containerRef.current || !textRef.current) return;

  //   const container = containerRef.current;
  //   const computedStyle = window.getComputedStyle(textRef.current);

  //   // 计算行高
  //   const lineHeight =
  //     parseFloat(computedStyle.lineHeight) ||
  //     parseFloat(computedStyle.fontSize) * 1.2;

  //   // 计算最大高度（根据行数）
  //   const maxHeight = lineHeight * maxLines;

  //   // 容器宽度减去预留空间（给"More"按钮）
  //   const containerWidth = container.offsetWidth - 50;

  //   // 创建临时测量元素
  //   const tempDiv = document.createElement("div");
  //   tempDiv.style.visibility = "hidden";
  //   tempDiv.style.position = "absolute";
  //   tempDiv.style.width = `${containerWidth}px`;
  //   tempDiv.style.font = computedStyle.font;
  //   tempDiv.style.lineHeight = computedStyle.lineHeight;
  //   tempDiv.style.whiteSpace = "normal";
  //   if (window.innerWidth <= mobileBreakpoint) {
  //     tempDiv.style.fontSize = "16px";
  //   } else {
  //     tempDiv.style.fontSize = "14px";
  //   }
  //   tempDiv.style.overflowWrap = "break-word";
  //   document.body.appendChild(tempDiv);

  //   // 使用二分查找确定最大字符数
  //   const binarySearchMaxChars = () => {
  //     let low = 0;
  //     let high = cardItem.prompt.length;
  //     let result = cardItem.prompt.length;

  //     while (low <= high) {
  //       const mid = Math.floor((low + high) / 2);
  //       tempDiv.textContent = cardItem.prompt.slice(0, mid) + "...";
  //       const textHeight = tempDiv.offsetHeight;

  //       if (textHeight <= maxHeight) {
  //         low = mid + 1;
  //         result = mid;
  //       } else {
  //         high = mid - 1;
  //       }
  //     }
  //     return result;
  //   };

  //   const tempMaxChars = binarySearchMaxChars();
  //   document.body.removeChild(tempDiv);
  //   setMaxChars(tempMaxChars);
  // }, [cardItem.prompt, maxLines]);

  // // 监听文本和容器变化
  // useEffect(() => {
  //   const handleResize = () => {
  //     calculateMaxChars();
  //   };

  //   calculateMaxChars();
  //   window.addEventListener("resize", handleResize);

  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, [calculateMaxChars]);

  // // 判断是否需要截断
  // const isTruncated = useMemo(() => {
  //   return cardItem.prompt.length > maxChars;
  // }, [cardItem.prompt, maxChars]);

  // 计算显示文本
  const displayText = useMemo(() => {
    if (isExpanded || !isTruncated) return cardItem.prompt;
    return `${cardItem.prompt.slice(0, maxChars)}...`;
  }, [isExpanded, isTruncated, cardItem.prompt, maxChars]);

  // 切换展开/收起状态
  const toggleExpand = useCallback(() => {
    setIsExpanded((prev) => !prev);
  }, []);

  return (
    <div
      className="bg-white  rounded-[6px] overflow-hidden shadow-[0px_2px_6px_0px_rgba(0,0,0,0.25)] border border-solid border-transparent hover:border-[#4338CA] transition-all duration-300 ease-out"
      ref={containerRef}
    >
      {/* User Info */}
      <div className="flex flex-row  md:items-center justify-between  gap-2 p-2">
        <div className="flex flex-row items-center max-h-fit gap-2">
          <span className="w-[20px] h-[20px] bg-[#C7D2FE] rounded-full flex flex-row items-center justify-center uppercase text-[14px] text-[#3730A3] font-semibold">
            {firstChar}
          </span>
          <span className="text-[#171717] text-[13px] md:text-[14px] font-semibold">
            {cardItem.username}
          </span>
          <span className="text-[#737373] text-[10px] md:text-[12px] italic">
            ({cardItem.time})
          </span>
        </div>

        <div className="flex flex-col-reverse md:flex-row items-end md:items-center gap-2 md:gap-3 flex-1 md:flex-none">
          <button
            className=" text-[#fff] text-[12px] md:text-[14px] font-medium flex-shrink-0 px-2 bg-[#4338CA] py-1 rounded"
            onClick={onSelected}
          >
            Try this case
          </button>
          <div className="ml-auto flex items-center justify-center">
            <span className="text-[#F74138] mr-1 flex flex-row items-center justify-center">
              <EmptyHeartIcon />
            </span>
            <span className="text-[#737373] text-[14px]">{cardItem.likes}</span>
          </div>
        </div>
      </div>

      {/* Image */}
      <div className="relative bg-[#171717] w-full h-[220px] flex-shrink-0 self-stretch flex flex-row items-center justify-center">
        <PhotoProvider>
          <PhotoView src={cardItem.image}>
            <img
              src={cardItem.image}
              alt="Generated content"
              className="max-w-full max-h-full"
            />
          </PhotoView>
        </PhotoProvider>
      </div>

      {/* Prompt and Button */}
      <div className="p-3 flex flex-row items-center justify-between gap-[10px]">
        <span
          className="text-[#525252] text-[14px] font-medium leading-normal whitespace-pre-line"
          ref={textRef}
        >
          {displayText}
          {isTruncated && !isExpanded && (
            <button
              className="ml-2 text-[#818CF8] underline"
              onClick={toggleExpand}
            >
              More
            </button>
          )}
          {isExpanded && (
            <button
              className="ml-2 text-[#818CF8] underline"
              onClick={toggleExpand}
            >
              Less
            </button>
          )}
        </span>
      </div>
    </div>
  );
};

export default ShowcaseCard;
